import React from 'react';
import Translate from '../../Translate/Translate';

interface Props {
  className?: string;
  type: string;
  name: string;
  keyword: string;
  id?: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input = ({
  className,
  type,
  name,
  keyword,
  id,
  value,
  onChange,
}: Props) => {
  return (
    <div
      className={`flex-[0_0_100%] mb-5 lg:flex-[0_0_50%] lg:-mr-1 lg:-ml-1 lg:my-0 lg:pt-0 lg:pb-7 lg:px-1 ${className}`}
    >
      <label htmlFor={id ?? name} className="block text-sm mb-3 font-axi-bold">
        <Translate component="login" keyword={keyword} />
      </label>
      <input
        className="rounded border h-12 w-full pl-4 border-solid border-rgrey-light"
        type={type}
        name={name}
        id={id ?? name}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default Input;
